<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [canGoBack]="true"
      [title]="'No Private Pros Added'" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>


    <tidy-row [align]="'center'">
      <tidy-text
        [body]="'Please add a private pro to assign this job.'" />
    </tidy-row>

    <tidy-row [align]="'center'">
      <tidy-text
        [body]="'There\'s no action needed from them for you to assign them. If they choose, they can view and manage the job in their own app <i>TIDY for Pros</i>.'" />
    </tidy-row>

    <tidy-button
      [text]="'Add & Assign Pro'"
      [action]="boundGoToAddPros"
      class="primary" />

    <tidy-row [align]="'center'" class="extra-top-padding">
      <tidy-text
        [title]="'Why Add Pros?'" />
    </tidy-row>

    @for (card of salesCards; track card; let last = $last; let first = $first) {
      <tidy-alert style="padding: 15px 15px 15px 10px">
        <tidy-grid>
          <tidy-row>
            <ion-row>
              <ion-col size="2" class="vertical-align-center">
                <div style="margin: auto">
                  <tidy-image
                    [src]="card?.image"
                    style="width:35px" />
                </div>
              </ion-col>
              <ion-col>
                <tidy-row>
                  <tidy-text
                    [header]="card?.title" />
                </tidy-row>
                <tidy-row>
                  <tidy-text
                    [body]="card?.text" />
                </tidy-row>
              </ion-col>
            </ion-row>
          </tidy-row>
        </tidy-grid>
      </tidy-alert>
    }

  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
